export const ROUTES = {
  HOME: "/",
  LOGIN: "/login",
  REGISTER: "/register",
  LOGIN_VERIFY: "/login/verify",
  EMAIL_CONFIRMATION: "/email-confirmation",
  EMAIL_CONFIRMED: "/email-confirmed",
  RESET_PASSWORD: "/reset-password",
  RESET_PASSWORD_EMAIL_SENT: "/reset-password-sent",
  AUTHORIZE_REDIRECT: "/authorize-redirect",
  CHOOSE_CONTEXT: "/choose-context",
  CALENDAR: "/calendar",
  TIME_SLOTS: "/time-slots",
  ATTENDANCE: "/attendance",
  ATTENDANCE_OCCURRENCE: "/attendance/:sessionId/:date",
  CREATE_SESSION: "/sessions/create",
  EDIT_SESSION: "/sessions/:id/edit",
  SESSIONS: "/sessions",
  SESSION_DETAILS: "/sessions/:id",
  MEMBERS: "/members",
  MEMBER_DETAILS: "/members/:id",
  CREATE_MEMBER: "/members/create",
  EDIT_MEMBER: "/members/:id/edit",
  GROUPS: "/members/groups",
  GROUP_DETAILS: "/members/groups/:id",
  CREATE_GROUP: "/members/groups/create",
  EDIT_GROUP: "/members/groups/:id/edit",
  HOME_PAGE: "/home",
  WELCOME_KIND: "/welcome/kind",
  SETTINGS: "/settings",
  ORGANIZATION_SETTINGS: "/settings/organization",
  PROGRAMMES_SETTINGS: "/settings/programmes",
  INVITATION: "/invitation",
  SUBSCRIPTION: "/subscription",
  TERMS_OF_SERVICE: "/terms",
  PRIVACY_POLICY: "/privacy",
  MEMBER_TERMS_OF_SERVICE: "/legal/terms",
  MEMBER_PRIVACY_POLICY: "/legal/privacy",
  BILLING: "/billing",
  MEMBER_BILLING: "/members/:id/billing",
  TRIAL_REQUESTS: "/trial-requests",
  WEBSITE: "/website",
  ABSENCES: "/absences",
  MATERIALS: "/materials",
  MESSAGES: "/messages",
  MESSAGE_THREAD: "/messages/:threadId",
  PORTAL: "/portal",
  PORTAL_LOGIN: "/portal/login",
  PORTAL_AUTH: "/portal/auth",
  PORTAL_MANDATE_SETUP: "/portal/mandate-setup",
  PORTAL_UNSUBSCRIBE: "/portal/unsubscribe",
  PORTAL_MONEY: "/portal/money",
  PORTAL_LIBRARY: "/portal/library",
  PORTAL_PROGRESS: "/portal/progress",
  PORTAL_ME: "/portal/me",
  PORTAL_MESSAGES: "/portal/messages",
  PORTAL_MESSAGE_THREAD: "/portal/messages/:threadId",
  ADMIN_USERS: "/admin/users",
  ADMIN_USER_MEMBERS: "/admin/users/:id/members",
  ADMIN_USER_ACTIVITY: "/admin/users/:id/activity",
  ADMIN_FEEDBACK: "/admin/feedback",
  ADMIN_REPORTS: "/admin/reports",
  ADMIN_ACQUISITION: "/admin/acquisition",
  ADMIN_REFERRALS: "/admin/referrals",
  ADMIN_REFERRAL_DETAILS: "/admin/referrals/:id",
  PARTNER_TERMS: "/partner/terms/:token",
  REFERRAL_PROGRAM: "/refer",
  ASSISTANT_IMPORT: "/import",
  ASSISTANT: "/assistant",
};

/** Public marketing site — where the header logo points for signed-out visitors. */
export const MARKETING_URL = "https://timeplanned.com/";
